
  import { Component, Vue } from 'vue-property-decorator'

  @Component
  export default class PagesCoreView extends Vue {
    private srcs: { [key: string]: string } = {
      '/pages/lock': 'lock.jpg',
      '/pages/login': 'login.jpg',
      '/pages/pricing': 'pricing.jpg',
      '/pages/register': 'register.jpg',
    }

    get src(): string {
      return this.srcs[this.$route.path]
    }

    get styles(): { padding: string } {
      const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 175 : 100
      const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 175 : 150
      return {
        padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
      }
    }
  }
